module.exports = __webpack_public_path__ + "img/android-settings.cb82f06c.svg";